import { createAsyncThunk } from "@reduxjs/toolkit";
import { foldersTemplateServices } from "../../../services/backOffice/folders/folders.service";
import { showHideLoader } from "../../common/common.slice";

// get All Root Folders Action
const getTemplateFoldersAction = createAsyncThunk(
       'foldersSlice/getTemplateFoldersAction', (_, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return foldersTemplateServices.getTemplateFoldersService()
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            });
    }
)

// get child folders action
const getChildFoldersAction = createAsyncThunk(
    'foldersSlice/getChildFoldersAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return foldersTemplateServices.getAllChildFoldersService(payload)
            .then((response) => {
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return response;
            })
            .catch((error: { response: unknown; }) => { 
                setTimeout(() => {
                    dispatch(showHideLoader(false));
                }, 500)
                return rejectWithValue(error?.response);
            }); 
    }
)

// create new folder action
const createNewFolderAction = createAsyncThunk(
    'foldersSlice/createNewFolderAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return foldersTemplateServices.createNewFolderService(payload)
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return response;
        })
        .catch((error: { response: unknown; }) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return rejectWithValue(error?.response);
        });
    }
)

// delete folder action
const deleteFolderAction = createAsyncThunk(
    'foldersSlice/deleteFolderAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return foldersTemplateServices.deleteFolderService(payload)
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return response;
        })
        .catch((error: { response: unknown; }) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return rejectWithValue(error?.response);
        });
    }
)

// rename folder action
const renameFolderAction = createAsyncThunk(
    'foldersSlice/renameFolderAction', (payload: any, { dispatch, rejectWithValue }) => {
        dispatch(showHideLoader(true));
        return foldersTemplateServices.renameFolderService(payload)
        .then((response) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return response;
        })
        .catch((error: { response: unknown; }) => {
            setTimeout(() => {
                dispatch(showHideLoader(false));
            }, 500)
            return rejectWithValue(error?.response);
        });
    }
)

export const foldersTemplateActions = {
    getTemplateFoldersAction,
    getChildFoldersAction,
    createNewFolderAction,
    deleteFolderAction,
    renameFolderAction
}